// Couche de localisation des données de tarification.
// Retourne les catalogues localisés selon la langue (fr = source, en = traduit).
import { PRICING, SUPPORT_INCLUDED, PROGERE_360 } from "./pricing";
import { PRICING_EN, SUPPORT_INCLUDED_EN, PROGERE_360_EN } from "./pricingEn";

export function localizePricing(lang) {
  if (lang !== "en") {
    return { pricing: PRICING, support: SUPPORT_INCLUDED, p360: PROGERE_360 };
  }

  const pricing = PRICING.map((m) => {
    const em = PRICING_EN[m.key] || {};
    return {
      ...m,
      subtitle: em.subtitle || m.subtitle,
      note: em.note || m.note,
      plans: m.plans.map((p) => {
        const ep = (em.plans && em.plans[p.tier]) || {};
        const merged = { ...p, features: ep.features || p.features };
        const addon = p.payroll || p.takeoff;
        if (addon) {
          const ea = ep.addon || {};
          const localizedAddon = {
            ...addon,
            name: ea.name || addon.name,
            features: ea.features || addon.features,
          };
          if (p.payroll) merged.payroll = localizedAddon;
          if (p.takeoff) merged.takeoff = localizedAddon;
        }
        return merged;
      }),
    };
  });

  const support = { ...SUPPORT_INCLUDED, subtitle: SUPPORT_INCLUDED_EN.subtitle, features: SUPPORT_INCLUDED_EN.features };
  const p360 = { ...PROGERE_360, subtitle: PROGERE_360_EN.subtitle, includes: PROGERE_360_EN.includes, benefits: PROGERE_360_EN.benefits };

  return { pricing, support, p360 };
}
